import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Countdown from "./components/countdown";
import NotFound from "./components/notFound";

export default function Routes(selectedImage) {
  return (
    <Router>
      <Switch>
        <Route exact path="/:event/:time">
          <Countdown selectedImage={selectedImage} />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
}
